var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.5,
    height: 27.581,
    viewBox: "0 0 29.5 27.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M15.75,28.231l-1.994-1.815C6.675,19.995,2,15.76,2,10.563A7.489,7.489,0,0,1,9.563,3,8.234,8.234,0,0,1,15.75,5.874,8.234,8.234,0,0,1,21.938,3,7.489,7.489,0,0,1,29.5,10.563c0,5.2-4.675,9.432-11.756,15.868Z",
    transform: "translate(-1 -2)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartIcon);
export default __webpack_public_path__ + "static/media/icon_heart_icon.abf1c04e462387419bef549f703f4dff.svg";
export { ForwardRef as ReactComponent };